import { categories } from '@/mocks/chigua';

export default function CategoryBand() {
  return (
    <section id="lanmu" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
            <i className="ri-grid-fill"></i> 栏目导航
          </p>
          <h2 className="heading-font mt-1.5 text-2xl font-extrabold text-foreground-950 md:text-3xl">
            按你喜欢的方向，挑瓜下手
          </h2>
        </div>
        <p className="hidden max-w-xs text-right text-xs leading-relaxed text-foreground-500 sm:block">
          六大栏目覆盖娱乐、影视、社会、科技、体育与生活，想看哪块点哪块。
        </p>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <a
            key={c.id}
            href="#ts"
            className="group flex items-start gap-4 rounded-lg border border-secondary-100 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-200"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <span className="flex min-w-0 flex-1 flex-col">
              <span className="flex items-center justify-between">
                <span className="heading-font text-base font-bold text-foreground-950">{c.name}</span>
                <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[10px] font-semibold text-accent-800 whitespace-nowrap">
                  {c.trend}
                </span>
              </span>
              <span className="mt-1 text-xs text-foreground-500">{c.blurb}</span>
              <span className="mt-2 flex items-center gap-3 text-[11px] text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-archive-line"></i> {c.count}
                </span>
                <span className="flex items-center gap-1 text-primary-500">
                  去看看 <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}